import $ from "jquery"
import SimpleTooltip from "../../../SimpleTooltip"
import TemplateView from "../../../TemplateView"
import UserTime from "../../../user_time"
import TruncatedTextView from "../../../TruncatedTextView";

export default class ReportedTimeRow extends TemplateView {
    constructor($containerEl) {
        super($containerEl);
    }

    templateHtml() {
        return "<tr class='timeRow'>" +
               " <td class='dateColumn'><span class='dateCell'/></td>" +
               " <td class='userColumn'><div class='userCell'/></td>" +
               " <td class='timeColumn'><span class='timeCell'/></td>" +
               " <td class='commentColumn'><div class='commentCell'/></td>" +
               "</tr>";
    }

    shouldUpdateOnInit() {
        return false;
    }

    afterRender() {
        this.date = null;
        this.user = null;
        this.time = null;
        this.comment = null;
        this.dateFormat = ReportedTimeRow.dateFormat;

        this.$dateCell = this.find('.dateCell');
        this.$userCell = this.find('.userCell');
        this.$timeCell = this.find('.timeCell');
        this.commentCell = new TruncatedTextView({lineCount: 3}).init(this.find('.commentCell'));
    }

    setRowData(date, user, time, comment) {
        this.date = date;
        this.user = user;
        this.time = time;
        this.comment = comment;
        this.update();
    }

    update() {
        this.$dateCell.text(this.date.format(this.dateFormat));
        this.$userCell.text(this.user);
        this.$timeCell.text(UserTime.formatTimeWithDigitSeparator(this.time));
        this.commentCell.setText(this.comment);
    }

    setDateFormat(dateFormat) {
        this.dateFormat = dateFormat;
    }
}

ReportedTimeRow.dateFormat = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M");


// WEBPACK FOOTER //
// ./web/js/panels/task/reportedTime/ReportedTimeRow.js